import { render, staticRenderFns } from "./SocialSharingModal.vue?vue&type=template&id=12795efc&scoped=true"
import script from "./SocialSharingModal.vue?vue&type=script&lang=js"
export * from "./SocialSharingModal.vue?vue&type=script&lang=js"
import style0 from "./SocialSharingModal.vue?vue&type=style&index=0&id=12795efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12795efc",
  null
  
)

export default component.exports